import { FAQS } from "../data/content";
import { PageHero, Reveal, Eyebrow, useSeo } from "../components/Reveal";
import { UrgentButton } from "../components/UrgentModal";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";

export default function FAQ() {
  useSeo(
    "FAQ | Mobile Drug, DNA & DOT Testing Questions — SwiftTest Solutions",
    "Answers to common questions about mobile testing dispatch, drug and DOT panels, legal DNA collection, employer programs, and billing in Eastern Iowa."
  );

  return (
    <div data-testid="faq-page">
      <PageHero
        testId="faq-hero"
        eyebrow="FAQ"
        title="Straight answers, no fine print"
        lead="Everything people usually ask before their first mobile collection. Still unsure? Call or text — a real person answers."
      />
      <section className="bg-background">
        <div className="mx-auto max-w-3xl space-y-14 px-5 pb-24 pt-16 sm:px-8">
          {FAQS.map((group) => (
            <Reveal key={group.category}>
              <Eyebrow>{group.category}</Eyebrow>
              <Accordion
                type="single"
                collapsible
                className="mt-5 space-y-3"
                data-testid={`faq-group-${group.category.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              >
                {group.items.map((item, i) => (
                  <AccordionItem
                    key={i}
                    value={`${group.category}-${i}`}
                    className="rounded-2xl border border-slate-200 bg-white px-6 shadow-sm"
                  >
                    <AccordionTrigger
                      data-testid={`faq-question-${group.category.slice(0, 4).toLowerCase()}-${i}`}
                      className="py-5 text-left font-display text-base font-bold text-slate-900 hover:no-underline"
                    >
                      {item.q}
                    </AccordionTrigger>
                    <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-600">
                      {item.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </Reveal>
          ))}
          <Reveal>
            <div className="rounded-3xl border border-teal-200 bg-teal-50 p-8 text-center">
              <h2 className="font-display text-xl font-bold text-teal-950">
                Didn't find your answer?
              </h2>
              <p className="mx-auto mt-2 max-w-md text-sm text-teal-900/80">
                Every situation is different — especially urgent ones. Reach out and we'll walk you
                through it.
              </p>
              <div className="mt-5 flex justify-center">
                <UrgentButton testId="faq-need-testing-now-button" />
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
